// extracted by mini-css-extract-plugin
export default {"nudgeCroutonTitle":"EwwPOF"};